import { Autocomplete } from "@mui/material"
import React, { FormEvent, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { InputField } from "../../../components/InputField"
import { useAuth } from "../../../contexts/AuthContext"
import { ENDPOINT } from "../../../constants"

const AddTelegramUser = () => {
  const { getUserJWT } = useAuth()

  const [kyzzenUsernames, setKyzzenUsernames] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [linking, setLinking] = useState(false)

  const getKyzzenUsernames = async () => {
    const userJWT = getUserJWT()
    try {
      setIsLoading(true)
      const res = await fetch(ENDPOINT.KYZZEN_USERNAMES, {
        headers: {
          "Content-type": "application/json",
          Authorization: userJWT ? `Bearer ${userJWT}` : "",
        },
      })
      const data = (await res.json()) as {
        count: number
        success: boolean
        data: string[]
      }
      setKyzzenUsernames(data.data)
    } catch (error) {
      console.log(error)
      toast.error((error as Error).message)
    } finally {
      setIsLoading(false)
    }
  }
  const linkTelegramManually = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const userJWT = getUserJWT()
    const formEl = e.currentTarget
    const form = new FormData(formEl)
    const { username, telegram_username } = Object.fromEntries(form) as Record<
      string,
      string
    >

    if (!telegram_username.includes("@")) {
      return toast.error("Telegram username must begin with @")
    }
    try {
      setLinking(true)
      const res = await fetch(ENDPOINT.LINK_TELEGRAM_MANUALLY, {
        body: JSON.stringify({
          username,
          telegram_username: telegram_username.substring(1),
        }),
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: userJWT ? `Bearer ${userJWT}` : "",
        },
      })
      const data = await res.json()

      if (!res.ok) throw new Error(data.message)
      formEl.reset()
      toast.success(data.message)
    } catch (error) {
      toast.error((error as Error).message)
    } finally {
      setLinking(false)
    }
  }

  useEffect(() => {
    getKyzzenUsernames()
  }, [])
  return (
    <div className="px-9 py-8 flex flex-col gap-5 h-[calc(100vh_-_120px)]">
      <header className="mb-3">
        <h1 className="font-semibold text-3xl text-left">Add Telegram User</h1>
      </header>
      <div className="h-full flex justify-center items-center">
        <form
          onSubmit={linkTelegramManually}
          className="max-w-md w-full flex flex-col gap-6"
        >
          <Autocomplete
            disablePortal
            options={kyzzenUsernames}
            sx={{ width: "100%" }}
            loading={isLoading}
            renderInput={(params) => (
              <div ref={params.InputProps.ref}>
                <input
                  type="text"
                  {...params.inputProps}
                  className="bg-transparent text-left text-gray-40 placeholder-gray-600 border-2 rounded-lg w-full px-4 py-3 border-kyzzen-secondary mx-0 bg-gray-90 read-only:opacity-50"
                  name="username"
                  placeholder="Kyzzen username"
                  required
                />
              </div>
            )}
          />
          <InputField
            type="text"
            name="telegram_username"
            className="w-full mx-0 bg-gray-90 border-gray-80 rounded-full mb-0"
            placeholder="Telegram username"
            required
          />
          <button
            type="submit"
            className="w-full py-3.5 px-6 bg-gradient text-kyzzen-primary  font-medium rounded-xl transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 flex items-center justify-center gap-3 shadow-lg"
          >
            {linking ? "Linking..." : "Link Telegram"}
          </button>
        </form>
      </div>
    </div>
  )
}

export default AddTelegramUser
